"use client";

import { Clock4, Ribbon } from "lucide-react";
import Title from "@/components/Title";
import BlogCard from "./_blogCard";
import SwiperComponent from "../ui/swiper-component";

export default function NewBlog({ fields, storage_prefix_url, isHomeBlog }) {
  const repeatableFields = fields?.repeatable_fields || [];

  const mobile_gutter = "px-4 md:px-10 lg:px-0";
  const mobile_swiper_gutter = "px-4! md:px-10! lg:px-0!";

  return (
    <div className="w-full mx-auto">
      {/* Title */}
      <div className={`flex items-center justify-between pb-4 ${mobile_gutter}`}>
        <div className="flex items-center gap-2">
          {fields?.icon === "clock" ? <Clock4 className="w-5 h-5 lg:w-6.5 lg:h-6.5" /> : fields?.icon === "ribbon" ? <Ribbon className="w-5 h-5 lg:w-6.5 lg:h-6.5" /> : ""}

          <Title
            type={fields?.title?.type}
            className="flex items-center text-jmt-main font-bold text-base md:text-lg border-b-2 border-jmt-primary-800"
          >
            {fields?.title?.title || ""}
          </Title>
        </div>
      </div>

      {/* Slider */}
      <SwiperComponent
        slides={repeatableFields.map((blog, index) => (
          <BlogCard
            key={blog?.id || index}
            blog={blog}
            storage_prefix_url={storage_prefix_url}
          />
        ))}
        breakpoints={{
          400: { slidesPerView: 1.5, spaceBetween: 16 },
          480: { slidesPerView: 2.5, spaceBetween: 16 },
          768: { slidesPerView: 3, spaceBetween: 16 },
          1024: { slidesPerView: 4, spaceBetween: 24 },
          1300: { slidesPerView: 5, spaceBetween: 24 },
        }}
        slidesPerView={1.5}
        spaceBetween={16}
        navigation={true}
        navPosition="side"
        hideNavOnMobile={!!isHomeBlog}
        grabCursor={true}
        swiper_className={mobile_swiper_gutter}
      />
    </div>
  );
}
